exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".iframeApp{\r\n    width: 100%;\r\n    height: 100%;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/dynamic/components/iFrame/iframe.component.css
// module id = ../../../../../src/app/components/utils/dynamic/components/iFrame/iframe.component.css
// module chunks = main